export const QUERY_KEY_CONSTANTS = {
  CSTS: 'csts',
  FILTERS: 'filters',
  FOCUSES: 'focuses',
  GLOBAL: 'global',
  ME: 'me',
  ORGANIZATIONS: 'organizations',
  SPIDRS: 'spidrs',
  SPIDR_BLUEPRINTS: 'spidr-blueprints',
  TRACK: 'track',
  ATTACHMENTS: 'attachments',
  EVENTS: 'events',
  SUMMARY: 'summary',
};
